module.exports = __webpack_public_path__ + "static/media/plugins.119b7533.svg";